import styled from 'styled-components';
import { WorkflowActionsMenu } from '../../../WorkflowBox/WorkflowActionsMenu';
import { Input } from '@salecycle/ui-component-library';
import useOpenDrawerSettings from '../../DisplayWebContent/hooks/useOpenDrawerSettings';
import { Variant } from '../../../../state/SplitTests/SplitTestsState';
import { useCallback } from 'react';
import { DefaultVariant } from '../../components/DefaultVariant';
import { WorkflowBadge } from '../../../Canvas/components/WorkflowBadge';

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.designToken.baseWhite};
  box-shadow: ${({ theme }) => theme.designToken.boxShadow0};
  padding: ${({ theme }) => theme.designToken.spacing4};
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  [data-testid='ActionsMenu'] {
    position: absolute;
    right: 0;
    left: -63px;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled.div`
  font: ${({ theme }) => theme.designToken.headingH3};
  margin: 0 ${({ theme }) => theme.designToken.spacing2};
`;

const Body = styled.div`
  display: flex;
  margin-top: ${({ theme }) => theme.designToken.spacing2};
  justify-content: flex-end;
  position: relative;
  margin-right: 30px;
  height: 48px;
  > div > div {
    margin: 0;
  }
  .input-state + div {
    right: -24px;
    top: 30%;
  }
`;

export function DrawVariantCard({
  variant,
  weight,
  onWeightChange,
}: {
  variant: Variant;
  weight: number;
  onWeightChange: (newWeight: number) => void;
}) {
  const { openDrawerSettings } = useOpenDrawerSettings();

  const handleInputChange = (value?: string) => {
    const numericValue = Number(value);
    if (numericValue >= 0 && numericValue <= 100) {
      onWeightChange(numericValue);
    }
  };

  const onEdit = useCallback(() => {
    openDrawerSettings(variant.messageId, 'display-web-content-variant-settings');
  }, [openDrawerSettings, variant.messageId]);

  return (
    <CardContainer>
      <Header>
        <TitleContainer>
          <WorkflowBadge variantId={variant.messageId} isCircle>
            {variant.name}
          </WorkflowBadge>
          <Title>Variant {variant.name}</Title>
          <DefaultVariant variantId={variant.messageId} />
        </TitleContainer>
        <WorkflowActionsMenu onEdit={onEdit} />
      </Header>
      <Body>
        <Input
          ariaLabel={`Variant ${variant.name}`}
          maxWidth="75px"
          numberInputUnit="%"
          type="number"
          value={weight}
          onChange={value => handleInputChange(value)}
        />
      </Body>
    </CardContainer>
  );
}
